export default __webpack_public_path__ + "static/media/rank001.3705b88b.png";